<div header-content>
    <pf-text header-name type="primary"
        >{{ column.headerName | AppConstantTemplate }}
    </pf-text>
    @if (column.showCheckbox) {
        <pf-checkbox
            id="headerCheckbox"
            [control]="checkboxControl"
            [tooltip]="column.checkboxLabel"
            labelPosition="right"
            inline></pf-checkbox>
    }
</div>
